export enum CustomEventsNameEnum {
  ClearInputValue = 'clearInputValue',
  MubiInstallmentsApplicationNotFilledError = 'mubiInstallmentsApplicationNotFilledError',
  MubiInstallmentsContractConfirmed = 'mubiInstallmentsContractConfirmed',
  TravelFiltersApplied = 'travelFiltersApplied',
  UpsaleInitialized = 'upsaleInitialized',
}
